
import { LOGIN_SUCCESS } from '../Types/User';
const initState = {user:null}
const UserReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            console.log("UserReducer LOGIN_SUCCESS");
            
            return {...state, user:action.payload.user }
        
        
        default:
            return state;
    }
};

export default UserReducer;



// WEBPACK FOOTER //
// ./src/Reducers/UserReducer.js